import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { euro } from '../../lib/format';
import { useToasts } from '../../lib/toast';
import type { AuditRow } from '@taj/types';

const META: Record<string, { label: string; color: string; bg: string }> = {
  PAYMENT: { label: 'Paiement', color: '#1f9150', bg: '#e6f5ec' },
  PAYMENT_VOID: { label: 'Paiement annulé', color: '#c0392b', bg: '#fbe2dd' },
  REFUND: { label: 'Remboursement', color: '#c0392b', bg: '#fbe2dd' },
  CANCEL: { label: 'Annulation', color: '#c0392b', bg: '#fbe2dd' },
  ORDER_CANCEL: { label: 'Annulation', color: '#c0392b', bg: '#fbe2dd' },
  ORDER_REOPEN: { label: 'Réouverture', color: '#c47012', bg: '#fdf0dd' },
  ORDER_COMPLETE: { label: 'Commande fermée', color: '#2a6fb0', bg: '#dbe9f7' },
  DISCOUNT: { label: 'Remise', color: '#8a5cc0', bg: '#ece1f7' },
  PRICE_CHANGE: { label: 'Prix modifié', color: '#8a5cc0', bg: '#ece1f7' },
  LOGIN: { label: 'Connexion', color: '#5f5642', bg: '#eeeae0' },
  PERMISSION_CHANGE: { label: 'Droits modifiés', color: '#8a5cc0', bg: '#ece1f7' },
};

function fmtDetail(detail: string | null): string {
  if (!detail) return '';
  try {
    const o = JSON.parse(detail);
    return Object.entries(o)
      .map(([k, v]) => (k.toLowerCase().includes('cents') && typeof v === 'number' ? `${k.replace(/Cents$/i, '')}: ${euro(v)}` : `${k}: ${v}`))
      .join(' · ');
  } catch { return detail; }
}

export function AuditManager({ onBack }: { onBack: () => void }) {
  const push = useToasts((s) => s.push);
  const [rows, setRows] = useState<AuditRow[]>([]);
  const [filter, setFilter] = useState('');

  const load = (action: string) => api.listAudit(action || undefined).then(setRows).catch((e) => push(e.message, 'warn'));
  useEffect(() => { load(filter); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const actionsPresent = Array.from(new Set(rows.map((r) => r.action)));

  return (
    <div className="staff-scroll">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '4px 0 14px', flexWrap: 'wrap' }}>
        <button className="km-back" onClick={onBack}>←</button>
        <div className="staff-title" style={{ fontSize: '1.4rem', flex: 1 }}>📜 Audit (journal)</div>
        <select className="inp" style={{ width: 'auto' }} value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="">Toutes les actions</option>
          {Object.keys(META).map((a) => <option key={a} value={a}>{META[a].label}</option>)}
        </select>
      </div>
      <div style={{ fontSize: '.82rem', color: 'var(--ink-faint)', marginBottom: 12, maxWidth: 620 }}>
        Journal horodaté et inaltérable de toutes les actions sensibles (annulations, remboursements, réouvertures,
        paiements…) — traçabilité NF525.
      </div>

      <div className="cc" style={{ maxWidth: 720 }}>
        {rows.length === 0 && <div style={{ fontSize: '.85rem', color: 'var(--ink-faint)' }}>Aucun événement{filter ? ' pour ce filtre' : ''}.</div>}
        {rows.map((r) => {
          const m = META[r.action] ?? { label: r.action, color: '#5f5642', bg: '#eee' };
          return (
            <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid var(--line)', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '.72rem', fontWeight: 800, color: m.color, background: m.bg, padding: '3px 9px', borderRadius: 20, whiteSpace: 'nowrap' }}>{m.label}</span>
              <div style={{ flex: '1 1 200px', minWidth: 160 }}>
                <div style={{ fontSize: '.85rem', fontWeight: 600 }}>{fmtDetail(r.detail) || '—'}</div>
                <div style={{ fontSize: '.74rem', color: 'var(--ink-faint)' }}>
                  {r.staffName ? `👤 ${r.staffName}` : '👤 système'}{r.targetId ? ` · réf ${r.targetId.slice(-6)}` : ''}
                </div>
              </div>
              <span style={{ fontSize: '.76rem', color: 'var(--ink-dim)', whiteSpace: 'nowrap' }}>{new Date(r.createdAt).toLocaleString('fr-FR')}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
